import axios from 'axios'
import { TEST_URl } from '@/utils/constants.js'

const defaultBaseUrl = `${process.env.VUE_APP_BASE_URL}/account`
const testUrl = localStorage.getItem(TEST_URl)
const testBaseUrl = `${testUrl}/account`
const baseUrl = testUrl ? testBaseUrl : defaultBaseUrl

export async function getAllToursService () {
  const res = await axios.get(`${baseUrl}/walkthrough`)
  return res
}
export async function updateTourStatusService (payload) {
  const res = await axios.put(`${baseUrl}/walkthrough`, payload)
  return res
}
